module.exports = __webpack_public_path__ + "img/void-part.48b9ce9a.png";